export const RoutesLink = {
  Login: '/',
  dashboard: '/dashboard',
  forgetPassword: '/forget-password',
  verifyOtp: '/verify-otp',
  newPassword: '/new-password',
  company: '/company',
  officeLocation: '/office',
  addOffice: '/add-office',
  addCompany: '/add-company',
  editCompany: '/edit-company',
  companyDetail: '/company-detail',
  leaveSetting: '/leave-setting',
  addLeaveSetting: '/add-leave-setting',
  shifts: '/shifts-time',
  holiday: '/holiday',
  holidays: '/holidays',
  addShift: '/add-shift',
  salaryHead: '/salary-head',
  addSalaryHead: '/add-salary-head',
  department: '/department',
  desgination: '/designation',
  addDesignation: '/add-desgination',
  underDevelopmentPage: '/under-development-page',
  attendance: '/attendance',
  employeeOnBoard: '/employee-onBoard',
  addEmployeeOnBoard: '/add-employee-onboard',
  teamAttendance: '/team-attendance',
  monthlyTeamAttendance: '/attendance-summary',
  monthlyTeamAttendanceDetail: '/attendance-summary-details',
  editEmployeeOnBoard: '/edit-employee-onboard',
  employeeDetail: '/employee-detail',
  myRegularization: '/my-regularization',
  manageBulkAttendance: '/manage-bulk-attendance',
  myWfh: '/my-wfh',
  wfhRequestDetail: '/wfh-request-detail',
  wfhTeamRequestDetail: '/wfh-team-request-detail',
  teamWfh: '/team-wfh',
  arRequestDetail: '/ar-request-detail',
  arTeamRequestDetail: '/ar-team-request-detail',
  teamAr: '/team-ar',
  myLeave: '/my-leave',
  addLeave: '/add-leave',
  teamLeave: '/team-leave',
  leaveDetail: '/leave-detail',
  leaveTeamDetail: '/leave-team-detail',
  myPaySlip: '/my-pay-slip',
  teamPayslips: '/pay-slip',
  payslipOfficeWise: '/pay-slip-office-wise',
  profile: '/profile',
  updateProfile: '/update-profile',
  salaryConfig: '/salary-config',
  siteSalaryHead: '/site-salary-head',
  notification: '/notification',
  addSiteSalaryHead: '/add-site-salary-head',
  attendanceLogs: '/attendance-log',
  biometricDevices: '/biometric-devices',
  assetsRequest: '/assets-request',
  assetsCategory: '/assets-category',
  assets: '/assets',
  addAsset: '/add-asset',
  assetDetail: "/asset-detail",
  assetRequests: '/asset-requests',
  policy: '/policy',
  assetCategoryDetail: '/asset-category-detail',
  employees: '/employee',
  detailEmployee: '/employee-info',
} as const;
